import { DsLinearWorkFormLinkInterface } from '../interfaces/ds-linear-work-form-link.interface';

export class DsLinearWorkFormLink {
  /**
   * The work id.
   */
  workId: number;

  /**
   * The form template id.
   */
  templateId: number;

  /**
   * Order in which the form template should be displayed.
   */
  templateOrder: number;

  /**
   * Creates an instance of DsLinearWorkFormLink.
   *
   * @param jsonData Json object.
   */
  constructor(jsonData: DsLinearWorkFormLinkInterface = {}) {
    this.workId = jsonData.linear_work_id || this.workId;
    this.templateId = jsonData.form_template_id || this.templateId;
    this.templateOrder = jsonData.form_template_order || this.templateOrder;
  }
}
